// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__1zD8h","searchInput":"SearchBar_searchInput__25KbB"};